import { generatePath, useLocation, useNavigate } from 'react-router';

/**
 * This hook return callback that navigate to previous route based on history location.state.from
 * @param {boolean} isIframe used to tell if there is iframe on the page,
 * navigate(-1) affects iframe, so navigate(location.state.from) is used in that case
 */

export const useNavigateBackByLocationState = (isIframe = false): (() => void) => {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    if (location.state?.history && isIframe) {
      navigate(generatePath(location.state?.history));
      return;
    }
    if (location.state?.history) {
      navigate(-1);
      return;
    }
    navigate('/');
  };
};
